import {ReportMobileDetails} from 'template'

export default function PbfLapKunjPerSales() {
  return <ReportMobileDetails />
}
